// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__LHslf","spinner":"Loader_spinner__oYMo5","spinner-d3wgkg":"Loader_spinner-d3wgkg__jhDzN"};